import { useMemo } from 'react';

import qs from 'qs';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useCurrentUserId, useSessionUuid } from 'src/app/shared/hooks/session';
import { useShortUrl } from 'src/app/shared/hooks/shortUrls';

type UtmMedium =
	| 'facebook_post'
	| 'reddit_group'
	| 'facebook_group'
	| 'facebook_story'
	| 'instagram_post'
	| 'instagram_story';

export function useShareUrlWithUtmParams(shareUrl: string | undefined, utmMedium: UtmMedium): string {
	const { resolveUrl, userAgent } = useUtilityContext();
	const currentUserId = useCurrentUserId();
	const sessionUuid = useSessionUuid();

	const fullUrlWithUtmParams = useMemo(() => {
		if (!shareUrl) return '';

		let slug: string | undefined;

		try {
			const url = new URL(shareUrl);
			slug = url.pathname.match(/\/p\/([^/?]+)/)?.[1];
		} catch {
			const match = shareUrl.match(/\/p\/([^/?]+)/);
			slug = match?.[1];
		}

		if (!slug) return shareUrl;

		const isApp = userAgent.isWebview;
		const utmTerm = isApp ? 'starter_dashboard_app' : 'starter_dashboard_web';

		const trackParams = qs.stringify(
			{
				...(currentUserId ? { recruiter: currentUserId } : {}),
				recruited_by_id: sessionUuid,
				utm_source: 'share_petition',
				utm_campaign: 'starter_dashboard_rts',
				utm_medium: utmMedium,
				utm_term: utmTerm,
			},
			{ encodeValuesOnly: true },
		);

		return resolveUrl(`/p/${slug}?${trackParams}`);
	}, [shareUrl, resolveUrl, currentUserId, sessionUuid, utmMedium, userAgent.isWebview]);

	return useShortUrl(fullUrlWithUtmParams);
}
